import { z } from 'zod';
export const FlowTestGenerationRequestStatusSchema = z.enum([
    'Pending',
    'Processing',
    'Succeeded',
    'Failed',
]);
export const FlowTestGenerationRequestStatus = FlowTestGenerationRequestStatusSchema.enum;
export const FlowTestCaseBranchKindSchema = z.enum(['Conditional', 'Switch', 'Error']);
export const FlowTestCaseBranchKind = FlowTestCaseBranchKindSchema.enum;
export const GeneratedFlowTestCaseSchema = z.object({
    name: z.string(),
    description: z.string(),
});
export const FlowTestCaseBranchApiSchema = z.object({
    key: z.string(),
    block_id: z.string(),
    block_name: z.string(),
    kind: FlowTestCaseBranchKindSchema,
    outcome: z.string(),
    description: z.string(),
});
export const FlowTestGenerationApiReportSchema = z.object({
    test_cases: z.array(GeneratedFlowTestCaseSchema),
    coverage: z.object({
        total_branches: z.number(),
        covered_branches: z.number(),
        covered_branch_keys: z.array(z.string()),
        uncovered_branches: z.array(FlowTestCaseBranchApiSchema),
    }),
});
export const FlowTestCaseBranchSchema = z.object({
    key: z.string(),
    blockId: z.string(),
    blockName: z.string(),
    kind: FlowTestCaseBranchKindSchema,
    outcome: z.string(),
    description: z.string(),
});
export const FlowTestGenerationCoverageSchema = z.object({
    totalBranches: z.number(),
    coveredBranches: z.number(),
    coveredBranchKeys: z.array(z.string()),
    uncoveredBranches: z.array(FlowTestCaseBranchSchema),
});
export const FlowTestGenerationResultSchema = z.object({
    testCases: z.array(GeneratedFlowTestCaseSchema),
    coverage: FlowTestGenerationCoverageSchema,
});
export const BaseFlowTestGenerationRequestSchema = z.object({
    flowDefinitionId: z.uuid(),
    organizationId: z.uuid(),
    requestedById: z.uuid(),
});
export const FlowTestGenerationRequestSchema = BaseFlowTestGenerationRequestSchema.extend({
    id: z.uuid(),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
    status: FlowTestGenerationRequestStatusSchema,
    result: FlowTestGenerationResultSchema.nullable(),
    errorMessage: z.string().nullable(),
    resetAt: z.iso.datetime().nullable(),
    resetById: z.uuid().nullable(),
});
/**
 * Body `POST /test-case-generation/generate` accepts. The organization and the user come
 * from the caller's session rather than the body, which is why only the definition is here.
 */
export const FlowTestGenerationStartBodySchema = z.object({
    flowDefinitionId: z.uuid().describe('The definition to write test cases for.'),
});
/** Path parameters the endpoints addressing one generation request accept. */
export const FlowTestGenerationRequestIdParamsSchema = z.object({
    requestId: z.uuid().describe('The generation request.'),
});
//# sourceMappingURL=flowTestGeneration.js.map